<template>
    <v-data-table
        :headers="racesHeaders"
        dense
        :items-per-page="itemPerPage"
        :items="results"
        item-key="raceId"
        class="elevation-1 pa-6"
        :footer-props="{
            'items-per-page-text': $t('dataTable.rowsPerPageText'),
            'items-per-page-all-text': $t('dataTable.rowsPerPageAllText')
        }"
        :no-data-text="$t('dataTable.noDataText')"
        :headerProps="{
            'sort-by-text': $t('dataTable.sortByText')
        }"
    >
        <template v-slot:header="{ props: { headers } }">
            <thead class="headTable">
                <tr>
                    <th v-for="h in headers" :key="h.text">{{ h.text }}</th>
                </tr>
                <tr class="bg-white">
                    <td class="pt-2">
                        <v-text-field 
                            class="mb-2" 
                            hide-details outlined dense 
                            v-model="eventDateFilterValue" 
                            type="text" 
                            :label="$t('results.event_date')"
                        ></v-text-field>
                    </td>
                    <td class="pt-2">
                        <v-text-field 
                            class="mb-2" 
                            hide-details outlined dense 
                            v-model="promNameFilterValue" 
                            type="text" 
                            :label="$t('results.prom_name')"
                        ></v-text-field>
                    </td>
                    <td class="pt-2">
                        <v-text-field 
                            class="mb-2" 
                            hide-details outlined dense 
                            v-model="eventNameFilterValue" 
                            type="text" 
                            :label="$t('results.event_name')"
                        ></v-text-field>
                    </td>
                    <td class="pt-2">
                        <v-text-field 
                            class="mb-2" 
                            hide-details outlined dense 
                            v-model="raceNameFilterValue" 
                            type="text" 
                            :label="$t('results.race_name')"
                        ></v-text-field>
                    </td>
                    <td>&nbsp;</td>
                </tr>
            </thead>
            <thead class="headTableMobile">
                <tr>
                    <td>
                        <v-expansion-panels class="my-2">
                            <v-expansion-panel>
                                <v-expansion-panel-header>{{$t('common.filters')}}</v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-row>
                                        <v-col cols="12" sm="6" class="py-0">
                                            <v-text-field class="mb-2" hide-details outlined dense v-model="eventDateFilterValue" type="text" :label="$t('results.event_date')"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" class="py-0">
                                            <v-text-field class="mb-2" hide-details outlined dense v-model="promNameFilterValue" type="text" :label="$t('results.prom_name')"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" class="py-0">
                                            <v-text-field class="mb-2" hide-details outlined dense v-model="eventNameFilterValue" type="text" :label="$t('results.event_name')"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" class="py-0">
                                            <v-text-field class="mb-2" hide-details outlined dense v-model="raceNameFilterValue" type="text" :label="$t('results.race_name')"></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </td>
                </tr>
            </thead>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
            <v-icon small @click="openWarning(item)">fas fa-search</v-icon>
        </template>
        <template v-slot:item.eventDate="{ item }">
            <span>{{ item.eventDate | formatDateForHumans(false) }}</span>
        </template>
    </v-data-table>
</template>

<script>
import { 
    VDataTable, VTextField, VRow, VCol, VExpansionPanels, VExpansionPanel, VExpansionPanelHeader, VExpansionPanelContent, VIcon
} from 'vuetify/lib';

export default {
    components: { VDataTable, VTextField, VRow, VCol, VExpansionPanels, VExpansionPanel, VExpansionPanelHeader, VExpansionPanelContent, VIcon },
    props: {
        results: { type: Array, default: () => [] }
    },
    data() {
        return {
            itemPerPage: 5,
            eventDateFilterValue: '',
            eventNameFilterValue: '',
            raceNameFilterValue: '',
            promNameFilterValue: ''
        };
    },
    computed: {
        racesHeaders() {
            return [
                {
                    text: this.$t("results.event_date"),
                    align: "",
                    sortable: false,
                    value: "eventDate",
                    filter: this.eventDateFilter
                },
                { text: this.$t("results.prom_name"), value: "promName", filter: this.promNameFilter },
                { text: this.$t("results.event_name"), value: "eventName", filter: this.eventNameFilter },
                { text: this.$t("results.race_name"), value: "raceName", filter: this.raceNameFilter },
                { text: this.$t("results.actions"), value: "actions", sortable: false }
            ];
        }
    },
    methods: {
        eventDateFilter(value){
            return this.$options.filters.formatDateForHumans(value).toLowerCase().includes(this.eventDateFilterValue.toLowerCase());
        },
        eventNameFilter(value){
            return value.toLowerCase().includes(this.eventNameFilterValue.toLowerCase());
        },
        promNameFilter(value){
            return value.toLowerCase().includes(this.promNameFilterValue.toLowerCase());
        },
        raceNameFilter(value){
            return value.toLowerCase().includes(this.raceNameFilterValue.toLowerCase());
        },
        openWarning(item) {
            this.$emit('openWarning',item);
        }
    }
}
</script>

<style scoped>
.headTable{
    background: #ccc;
}
.headTable .bg-white{
    background: #fff !important;
}
</style>